import React, { useState, useEffect } from "react"
import FullCalendar from "@fullcalendar/react"
import dayGridPlugin from "@fullcalendar/daygrid"
import "@fullcalendar/common/main.css"
import "@fullcalendar/daygrid/main.css"
import "./meal-planner.css"
import { serverAPI } from "../../services/api/apiParams"
import Button from "react-bootstrap/Button"
import Modal from "react-bootstrap/Modal"
import Alert from "react-bootstrap/Alert"

function MealPlannerCal({ user }) {
  const [mealEvents, setMealEvents] = useState([])
  const [mealToDelete, setMealToDelete] = useState()
  const dayGrid = window.innerWidth > 576 ? "dayGridMonth" : "dayGridDay"

  // delete modal
  const [show, setShow] = useState(false)

  const handleClose = () => setShow(false)
  const handleShow = () => setShow(true)

  useEffect(() => {
    const fetchEvents = async () => {
      const res = await serverAPI.get("api/meal-event", {
        headers: {
          content: "application/json",
        },
      })
      setMealEvents(res.data)
    }
    fetchEvents()
  }, [])

  const showDeleteModal = (event) => {
    handleShow()
    setMealToDelete(event)
  }

  const deleteEvent = (event) => {
    const mealEventId = event.event._def.publicId
    const deleteApi = async () => {
      try {
        await serverAPI.delete(`api/meal-event/${mealEventId}`, {
          headers: {
            Accept: "application/json",
          },
        })
        setMealEvents((prev) => {
          return prev.filter((item) => item.id != mealEventId)
        })
      } catch (error) {
        console.log(error)
      }
    }
    deleteApi()
    handleClose()
  }

  const eventMouseEnter = () => {
    document.body.style.cursor = "pointer"
  }
  const eventMouseLeave = () => {
    document.body.style.cursor = "default"
  }
  if (user?.id == undefined) {
    return (
      <Alert className='mt-2 alert text-center popup-alert h-75'>
        You are not logged in. Please log in to access this page.
      </Alert>
    )
  }
  return (
    <div className='fullCalendar__container'>
      <FullCalendar
        plugins={[dayGridPlugin]}
        initialView={dayGrid}
        events={mealEvents}
        eventClick={showDeleteModal}
        eventMouseEnter={eventMouseEnter}
        eventMouseLeave={eventMouseLeave}
      />
      {show && (
        <Modal show={show} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Confirm Deletion</Modal.Title>
          </Modal.Header>
          <Modal.Body>Are you sure you want to delete this event?</Modal.Body>
          <Modal.Footer>
            <Button className='myBtn' onClick={handleClose}>
              Close
            </Button>
            <Button
              className='myBtn'
              onClick={() => {
                deleteEvent(mealToDelete)
              }}>
              Confirm
            </Button>
          </Modal.Footer>
        </Modal>
      )}
    </div>
  )
}

export default MealPlannerCal
